import React from "react"
import { Button } from 'primereact/button';
import { AzureUser, FormSectionElements, FormSections, FormSubSections, ProgramContainer } from "../entities/formTemplateDataType";
import { InputText } from "primereact/inputtext";
import { SelectButton } from "primereact/selectbutton";
import { Panel } from "primereact/panel";
import { InputTextarea } from "primereact/inputtextarea";
import { Dropdown } from "primereact/dropdown";
import { authticationMethodList, elementTypeList, EnvBaseUrl, TOKEN_TYPE } from "../entities/Constants";
import { TableComponent } from "./subComponent/TableComponent";
import { MoreButtonComponent } from "./subComponent/MoreButtonComponent";
import URLUtils from "../utilities/URLUtils";
import axios from "axios";
import { Toast } from 'primereact/toast';
import { DialogForAPIComponent } from "./subComponent/DialogforAPIComponent";
import { SplitButton } from "primereact/splitbutton";
import { FileUpload } from "primereact/fileupload";
import { ConfirmDialog } from 'primereact/confirmdialog';
import { DialogForSectionPropertyComponent } from "./subComponent/DialogForSectionPropertyComponent";
import { Editor } from "primereact/editor";
import 'primereact/resources/primereact.css';                       // core css
import 'primeicons/primeicons.css';                                 // icons
import 'primeflex/primeflex.css';                                   // css utility
import { PdfUtils } from '../utilities/PdfUtils';
import { Checkbox } from "primereact/checkbox";
import { DropdownDesignComponent } from "./subComponent/DropdownDesignComponent";
import { GroupDropdownDesignComponent } from "./subComponent/GroupDropdownDesignComponent";
import { DropdownWithRichTextDesignComponent } from "./subComponent/DropdownWithRichTextDesignComponent";

import { InputNumber } from 'primereact/inputnumber';
import StarRating from "../runtimeComponent/subComponent/StarRatingComponent";
import QRCodeComponent from "../runtimeComponent/subComponent/QRCodeComponent";
import { DialogForHelpComponent } from "./subComponent/DialogForHelpComponent";
import { AutoComplete, AutoCompleteCompleteEvent } from "primereact/autocomplete";
import AccordionsDesignComponent from "./subComponent/AccordionsDesignComponent";
import { AccordionData } from "src/commonComponent/AccordionsComponent";
import { getRootComponent } from "../utilities/ElementUtils";
import { TableMenuDesignComponent } from "./subComponent/TableMenuDesignComponent";
import SessionStorageService from "../services/SessionStorageService";
import { parseJson, stringifyJson } from "../utilities/JsonUtils";
import { useAZUserSearch } from "../services/AzService";
import AzureUsersLookUpComponent from "./subComponent/AzureUsersLookUpComponent";
import { User } from "src/entities/User";

interface Props {
    programContainer: ProgramContainer;
    isEng: boolean;
    dialogVisible: boolean;
    callback: (programContainer: ProgramContainer)=>void;
    callBackLang: (isEng:boolean)=>void
}
interface State {
    templateList;
    dialogVisible: boolean;
    apiDialogVisible: boolean[];
    panelCollapsed: boolean[];
    confirmCallback?: () => void;
    confirmVisible: boolean;
    sectionDialogVisible: boolean[];
    helpDialogVisible: boolean;
}


export class FormDesignComponent extends React.Component<Props, State> {
    growl: Toast;
    attachment: {};
    line1;
    ref;
    displayFormLsit = [
        { description: 'Stepper', value: 'stepper' },
        { description: 'Stepper without step title', value: 'NoIndicatorStepper' },
        { description: 'Stepper with step title', value: 'hiddenStepperWithSectionTitle' },
        { description: 'Hidden stepper', value: 'hiddenStepper' },
        { description: 'Progress bar as stepper', value: 'progressBarStepper' },
        { description: 'Panel', value: 'panel' },
    ];
    HeaderList = [
        { description: 'Application', value: 'Application' },
        { description: 'ServiceOntario', value: 'ServiceOntario' },
        { description: 'Ontario.ca', value: 'Ontario' },
    ];
    constructor(props: Props) {

        super(props);

        this.state = {
            templateList: [],
            dialogVisible: false,
            apiDialogVisible: [],
            panelCollapsed: [],
            confirmVisible: false,
            sectionDialogVisible: [],
            helpDialogVisible: false,
        }
    }

    
    showConfirmation = (callback?: () => void) => {
        this.setState({
            confirmVisible: true,
            confirmCallback: callback,
        });
    };

    confirmRemove = (confirmed: boolean) => {
        if (confirmed) {
            const callback = this.state.confirmCallback;
            if (callback) {
                callback();
            }
        }

        this.setState({
            confirmVisible: false,
        });
    };

    componentDidMount(): void {

        const token = SessionStorageService.getAccessToken(TOKEN_TYPE.API);
        console.log("token",token);
        const headers = {
            'Authorization': `Bearer ${token}`
        }
        
        let api = URLUtils.concatUrls("data/admin/all-template");
        axios.get(api, { headers: headers })
            .then((result) => {
                if (result.data != null) {
                    let templateList = result.data.map(p => {
                        return { "code": p.attachment, "description": p.categoryName + " (" + p.userName + ")" }
                    });
                    this.setState({ templateList: templateList });
                }
            })
            .catch(error => {
                console.error('Error fetching templates:', error);
            });
    }

    generateForm = () => {
        const options = ['English', 'French'];
        let htmlString = [];
        let panelArray = [];
        let formSectionsList = this.props.programContainer.ListOfFormSections;
        const divStyle = {
            backgroundColor: '#d3d3d3', // Specify the desired background color
            padding: '10px',
            marginBottom: '10px',
        };

        this.props.programContainer.ListOfFormSections.forEach(ele => {
            panelArray[ele.Id] = true;
        })

        htmlString.push(
            <div key={"form_"} style={{ width: '100%' }} >
                <div>
                    <div style={{ display: this.props.programContainer.EnglishOnly?"none": 'flex', justifyContent: 'end', marginBottom: '20px' }} >
                        {/* @ts-ignore */}
                        <SelectButton
                            value={this.props.isEng ? 'English' : 'French'}
                            onChange={(e) => this.props.callBackLang(e.value == 'English')} options={options} />
                    </div>

                    <div style={{ display: 'flex', marginBottom: '20px', marginTop: '10px' }} >
                        {/* @ts-ignore */}
                        <Button label="Expand" className="p-button-text"
                            onClick={() => {
                                const updatedPanelArray = panelArray.map(() => false); // Set all elements to false (expanded)
                                updatedPanelArray['Header'] = false;
                                this.setState({ panelCollapsed: updatedPanelArray });
                            }} />
                        {/* @ts-ignore */}
                        <Button label="Collapse" className="p-button-outlined p-button-secondary" style={{ marginLeft: '5px', border: '1px solid grey', color: 'grey' }}
                            onClick={() => {

                                const updatedPanelArray = panelArray.map(() => true); // Set all elements to false (collapsed)
                                updatedPanelArray['Header'] = true;
                                this.setState({ panelCollapsed: updatedPanelArray });
                            }} />
                    </div>
                    {/* @ts-ignore */}
                    <Panel header='Form Header' toggleable collapsed={this.state.panelCollapsed['Header']} onToggle={(e) => {
                        let panelArray = this.state.panelCollapsed;
                        panelArray['Header'] = e.value;
                        this.setState({
                            panelCollapsed: panelArray
                        })
                    }}>
                        <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                            <div style={{ width: '14%' }}>
                                Application ID:
                            </div>
                            <InputText value={this.props.programContainer.CategoryId || ''} keyfilter={/^\S+$/} className='ontario-input' title="Category ID" onChange={(e) => {
                                this.props.programContainer.CategoryId = e.target.value;
                                this.props.callback( this.props.programContainer);
                            }} />
                        </div>

                        <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                            <div style={{ width: '14%' }}>
                                Application Name:
                            </div>
                           
                            <InputText value={(this.props.isEng ? this.props.programContainer.Name : this.props.programContainer.NameFRA) || ''}
                                className='ontario-input' onChange={(e) => {

                                    if (this.props.isEng) {
                                        this.props.programContainer.Name = e.target.value;
                                    }
                                    else {
                                        this.props.programContainer.NameFRA = e.target.value;
                                    }
                                    
                                    this.props.callback( this.props.programContainer);
                                    e.target.focus();
                                }} />
                        </div>

                        <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                            <div style={{ width: '14%' }}>
                                Application title:
                            </div>
                           
                            <InputText value={(this.props.isEng ? this.props.programContainer.AppTitle?.en : this.props.programContainer.AppTitle?.fr)}
                                className='ontario-input' onChange={(e) => {
                                    if (this.props.isEng) {
                                        this.props.programContainer.AppTitle = {...this.props.programContainer.AppTitle ?? {}, en: e.target.value};
                                    } else {
                                        this.props.programContainer.AppTitle = {...this.props.programContainer.AppTitle ?? {}, fr: e.target.value};
                                    }
                                    
                                    this.props.callback( this.props.programContainer);
                                    e.target.focus();
                                }} />
                        </div>

                        <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                            <div style={{ width: '14%' }}>
                                Authentication Method:
                            </div>
                            {/* @ts-ignore */}
                            <Dropdown
                                // className="p-dropdown"
                                placeholder="Select authentication method"
                                options={authticationMethodList}
                                optionLabel="label"
                                optionValue="val"
                                value={this.props.programContainer.AuthRequired}
                                onChange={(e) => {
                                    this.props.programContainer.AuthRequired = e.value;
                                    this.props.callback( this.props.programContainer);
                                }}></Dropdown>
                        </div>

                        <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                            <div style={{ width: '14%' }}>
                                For Siebel Embedded:
                            </div>
                            <div style={{ alignItems: 'center', marginTop: '5px' }}>
                                {/* @ts-ignore */}
                                <Checkbox checked={this.props.programContainer.ForSiebel == 'Y'} value={this.props.programContainer.ForSiebel}
                                    className='p-checkbox' title="For Siebel"
                                    onChange={(e) => {
                                        this.props.programContainer.ForSiebel = e.checked ? 'Y' : 'N';
                                        this.props.callback( this.props.programContainer);
                                    }} />
                            </div>


                            <div style={{ display: this.props.programContainer.ForSiebel == 'Y' ? "flex" : 'none', marginLeft: '10px', }}>
                                Int Object Name:
                            </div>
                            <div style={{ width: 'auto' }}>
                                <InputText style={{ display: this.props.programContainer.ForSiebel == 'Y' ? "flex" : 'none', marginLeft: '10px', width: '100%' }} value={this.props.programContainer.IntObjectName} className='ontario-input' title="Int Object Name"
                                    onChange={(e) => {
                                        this.props.programContainer.IntObjectName = e.target.value;
                                        this.props.callback( this.props.programContainer);
                                    }} />
                            </div>

                        </div>


                        <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                            <div style={{ width: '14%' }}>
                                API Base Path:
                            </div>

                            <InputText value={this.props.programContainer.APIBasePath || ''} className='ontario-input' title="API Base Path"
                                onChange={(e) => {
                                    this.props.programContainer.APIBasePath = e.target.value;
                                    this.props.callback( this.props.programContainer);
                                }} />
                        </div>


                        <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                            <div style={{ width: '14%' }}>
                                Get API:
                            </div>

                            <InputText value={this.props.programContainer.GetAPI || ''} className='ontario-input' title="Get API"
                                onChange={(e) => {
                                    this.props.programContainer.GetAPI = e.target.value;
                                    this.props.callback( this.props.programContainer);
                                }} />
                        </div>

                        <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                            <div style={{ width: '14%' }}>
                                Create API:
                            </div>

                            <InputText value={this.props.programContainer.CreateAPI || ''} className='ontario-input' title="Create API"
                                onChange={(e) => {
                                    this.props.programContainer.CreateAPI = e.target.value;
                                    this.props.callback( this.props.programContainer);
                                }} />
                        </div>

                        <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                            <div style={{ width: '14%' }}>
                                Update API:
                            </div>

                            <InputText value={this.props.programContainer.UpdateAPI || ''} className='ontario-input' title="Update API"
                                onChange={(e) => {
                                    this.props.programContainer.UpdateAPI = e.target.value;
                                    this.props.callback( this.props.programContainer);
                                }} />
                        </div>

                        <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                            <div style={{ width: '14%' }}>
                                Delete API:
                            </div>

                            <InputText value={this.props.programContainer.DeleteAPI || ''} className='ontario-input' title="Delete API"
                                onChange={(e) => {
                                    this.props.programContainer.DeleteAPI = e.target.value;
                                    this.props.callback( this.props.programContainer);
                                }} />
                        </div>

                        {/*Stepper Selection*/}
                        <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                            <div style={{ width: '14%' }}>
                                Display Type:
                            </div>
                            {/* @ts-ignore */}
                            <Dropdown
                                // className="p-dropdown"
                                placeholder="Select a stepper type"
                                options={this.displayFormLsit}
                                optionLabel="description"
                                optionValue="value"
                                value={this.props.programContainer.displayForm}
                                onChange={(e) => {
                                    this.props.programContainer.displayForm = e.value;
                                    this.props.callback(this.props.programContainer);
                                }}></Dropdown>
                        </div>
                        <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                            <div style={{ width: '14%' }}>
                                Has Save Draft Button:
                            </div>
                            <div style={{ alignItems: 'center', marginTop: '5px' }}>
                                {/* @ts-ignore */}
                                <Checkbox checked={this.props.programContainer.HasSaveDraftButton == 'Y'} value={this.props.programContainer.HasSaveDraftButton}
                                    className='p-checkbox' title="Has Save Draft Button"
                                    onChange={(e) => {
                                        this.props.programContainer.HasSaveDraftButton = e.checked ? 'Y' : 'N';
                                        this.props.callback( this.props.programContainer);
                                    }} />
                            </div>
                        </div>
                        <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                            <div style={{ width: '14%' }} >
                                Checkbox Value Y/N:
                            </div>
                            <div style={{ alignItems: 'center', marginTop: '5px' }}>
                                {/* @ts-ignore */}
                                <Checkbox checked={this.props.programContainer.CheckboxValueYN == 'Y'} value={this.props.programContainer.CheckboxValueYN}
                                    className='p-checkbox' title="For some system, boolean value is represented by Y/N"
                                    onChange={(e) => {
                                        this.props.programContainer.CheckboxValueYN = e.checked ? 'Y' : 'N';
                                        this.props.callback( this.props.programContainer);
                                    }} />
                            </div>
                        </div>
                        <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                            <div style={{ width: '14%' }} >
                                Use Form Service as Proxy to Access Business API:
                            </div>
                            <div style={{ alignItems: 'center', marginTop: '5px' }}>
                                {/* @ts-ignore */}
                                <Checkbox checked={this.props.programContainer.UseProxy == 'Y'} value={this.props.programContainer.UseProxy}
                                    className='p-checkbox' title="Go through Form service to avoid CORS issue"
                                    onChange={(e) => {
                                        this.props.programContainer.UseProxy = e.checked ? 'Y' : 'N';
                                        this.props.callback( this.props.programContainer);
                                    }} />
                            </div>
                        </div>

                        <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                            <div style={{ width: '14%' }} >
                                Remove Review:
                            </div>
                            <div style={{ alignItems: 'center', marginTop: '5px' }}>
                                {/* @ts-ignore */}
                                <Checkbox checked={this.props.programContainer.NoReview == 'Y'} value={this.props.programContainer.NoReview}
                                    className='p-checkbox' title="No review page needed"
                                    onChange={(e) => {
                                        this.props.programContainer.NoReview = e.checked ? 'Y' : 'N';
                                        this.props.callback( this.props.programContainer);
                                    }} />
                            </div>
                        </div>

                        <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                            <div style={{ width: '14%' }} >
                                Use asterisks for required fields:
                            </div>
                            <div style={{ alignItems: 'center', marginTop: '5px' }}>
                                {/* @ts-ignore */}
                                <Checkbox checked={this.props.programContainer.UseAsterisks == 'Y'} value={this.props.programContainer.UseAsterisks}
                                    className='p-checkbox' title="Use asterisks for required fields"
                                    onChange={(e) => {
                                        this.props.programContainer.UseAsterisks = e.checked ? 'Y' : 'N';
                                        this.props.callback( this.props.programContainer);
                                    }} />
                            </div>
                        </div>

                        <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                            <div style={{ width: '14%' }} >
                                Select Header:
                            </div>
                            <div style={{ alignItems: 'center', marginTop: '5px' }}>
                                {/* @ts-ignore */}
                                <Dropdown
                                   placeholder="Select header"
                                    options={this.HeaderList}
                                    optionLabel="description"
                                    optionValue="value"
                                    value={this.props.programContainer.HeaderType}
                                    onChange={(e) => {
                                        this.props.programContainer.HeaderType = e.value;
                                        this.props.callback(this.props.programContainer);
                                    }}></Dropdown>
                            </div>
                        </div>

                        <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                            <div style={{ width: '14%' }} >
                                Ontario chat:
                            </div>
                            <div style={{ alignItems: 'center', marginTop: '5px' }}>
                                {/* @ts-ignore */}
                                <Checkbox checked={this.props.programContainer.OntarioChat} value={this.props.programContainer.OntarioChat}
                                    className='p-checkbox' 
                                    onChange={(e) => {
                                        this.props.programContainer.OntarioChat = e.checked;
                                        this.props.callback( this.props.programContainer);
                                    }} />
                            </div>
                        </div>

                        <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                            <div style={{ width: '14%' }} >
                               No Clear Button:
                            </div>
                            <div style={{ alignItems: 'center', marginTop: '5px' }}>
                                {/* @ts-ignore */}
                                <Checkbox checked={this.props.programContainer.NoClearButton == 'Y'} value={this.props.programContainer.NoClearButton}
                                    className='p-checkbox' 
                                    onChange={(e) => {
                                        this.props.programContainer.NoClearButton = e.checked ? 'Y' : 'N';
                                        this.props.callback( this.props.programContainer);
                                    }} />
                            </div>
                        </div>

                        <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                            <div style={{ width: '14%' }} >
                               Timeout Popup:
                            </div>
                            <div style={{ alignItems: 'center', marginTop: '5px' }}>
                                {/* @ts-ignore */}
                                <Checkbox checked={this.props.programContainer.TimeoutPopup} value={this.props.programContainer.TimeoutPopup}
                                    className='p-checkbox' 
                                    onChange={(e) => {
                                        this.props.programContainer.TimeoutPopup = e.checked;
                                        this.props.callback( this.props.programContainer);
                                    }} />
                            </div>
                        </div>

                        <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                            <div style={{ width: '14%' }}>
                                GA Tracking ID:
                            </div>

                            <InputText value={this.props.programContainer.GATrackingID || ''} className='ontario-input' title="Google Analytics tracking ID"
                                onChange={(e) => {
                                    this.props.programContainer.GATrackingID = e.target.value;
                                    this.props.callback( this.props.programContainer);
                                }} />
                        </div>

                        <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                            <div style={{ width: '14%' }} >
                               Sent Page Data to GA:
                            </div>
                            <div style={{ alignItems: 'center', marginTop: '5px' }}>
                                {/* @ts-ignore */}
                                <Checkbox checked={this.props.programContainer.sendPageDataToGA} value={this.props.programContainer.sendPageDataToGA}
                                    className='p-checkbox' 
                                    onChange={(e) => {
                                        this.props.programContainer.sendPageDataToGA = e.checked;
                                        this.props.callback( this.props.programContainer);
                                    }} />
                            </div>
                        </div>

                        <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                            <div style={{ width: '14%' }}>
                                Redirect URL:
                            </div>

                            <InputText value={(this.props.isEng ? this.props.programContainer.RedirectURL: this.props.programContainer.RedirectURLFRA) || ''}  className='ontario-input' title="Redirect URL"
                                onChange={(e) => {
                                    if (this.props.isEng) {
                                        this.props.programContainer.RedirectURL = e.target.value;
                                    } else {
                                        this.props.programContainer.RedirectURLFRA = e.target.value;
                                    }
                                    this.props.callback( this.props.programContainer);
                                }} />
                        </div>
                        <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                            <div style={{ width: '14%' }}>
                                Origin Text:
                            </div>

                            <InputText value={(this.props.isEng ? this.props.programContainer.Origin: this.props.programContainer.OriginFRA) || ''}  className='ontario-input' title="Go back to"
                                onChange={(e) => {
                                    if (this.props.isEng) {
                                        this.props.programContainer.Origin = e.target.value;
                                    } else {
                                        this.props.programContainer.OriginFRA = e.target.value;
                                    }
                                    this.props.callback( this.props.programContainer);
                                }} />
                        </div>

                        <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                            <div style={{ width: '14%' }}>
                                Origin URL:
                            </div>

                            <InputText value={(this.props.isEng ? this.props.programContainer.OriginURL: this.props.programContainer.OriginURLFRA) || ''}  className='ontario-input' title="Go back to URL"
                                onChange={(e) => {
                                    if (this.props.isEng) {
                                        this.props.programContainer.OriginURL = e.target.value;
                                    } else {
                                        this.props.programContainer.OriginURLFRA = e.target.value;
                                    }
                                    this.props.callback( this.props.programContainer);
                                }} />
                        </div>

                        <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                            <div style={{ width: '14%' }} >
                               Build in Social Media: 
                            </div>
                            <div style={{ alignItems: 'center', marginTop: '5px' }}>
                                {/* @ts-ignore */}
                                <Checkbox checked={this.props.programContainer.SocialMedia == 'Y'} value={this.props.programContainer.SocialMedia}
                                    className='p-checkbox' 
                                    onChange={(e) => {
                                        this.props.programContainer.SocialMedia = e.checked ? 'Y' : 'N';
                                        this.props.callback( this.props.programContainer);
                                    }} />
                            </div>
                        </div>

                        <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                            <div style={{ width: '14%' }} >
                               Already Deployed to Production:
                            </div>
                            <div style={{ alignItems: 'center', marginTop: '5px' }}>
                                {/* @ts-ignore */}
                                <Checkbox checked={this.props.programContainer.Deployed} value={this.props.programContainer.Deployed}
                                    className='p-checkbox' 
                                    onChange={(e) => {
                                        this.props.programContainer.Deployed = e.checked
                                        this.props.callback( this.props.programContainer);
                                    }} />
                            </div>
                        </div>

                        <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                            <div style={{ width: '14%' }} >
                               English Only:
                            </div>
                            <div style={{ alignItems: 'center', marginTop: '5px' }}>
                                {/* @ts-ignore */}
                                <Checkbox checked={this.props.programContainer.EnglishOnly} value={this.props.programContainer.EnglishOnly}
                                    className='p-checkbox' 
                                    onChange={(e) => {
                                        this.props.programContainer.EnglishOnly = e.checked;
                                        this.props.callback( this.props.programContainer);
                                    }} />
                            </div>
                        </div>

                        <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                            <div style={{ width: '14%' }} >
                               Help Option:
                            </div>
                            <div style={{ alignItems: 'center', marginTop: '5px', width: '5%' }}>
                                {/* @ts-ignore */}
                                <Checkbox checked={this.props.programContainer.HelpOption} value={this.props.programContainer.HelpOption}
                                    className='p-checkbox' 
                                    onChange={(e) => {
                                        this.props.programContainer.HelpOption = e.checked;
                                        this.props.callback( this.props.programContainer);
                                    }} />
                            </div>
                            <div style={{ alignItems: 'center', marginTop: '5px' }}>
                                {/* @ts-ignore */}
                                <Button 
                                    onClick={() => {this.setState({helpDialogVisible: true})}}>
                                    Help properties
                                </Button>
                            </div>
                        </div>


                        <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                            <div style={{ width: '14%' }}>
                                Feedback URL:
                            </div>
                            {/* @ts-ignore */}
                            <InputText value={this.props.isEng ? this.props.programContainer.FeedbackURL : this.props.programContainer.FeedbackURLFRA}
                                onChange={(e) => {
                                    if (this.props.isEng) {
                                        this.props.programContainer.FeedbackURL = e.target.value;
                                    } else {
                                        this.props.programContainer.FeedbackURLFRA = e.target.value;
                                    }

                                    this.props.callback(this.props.programContainer);
                                }} />
                        </div>

                        <div style={{display: (this.state.helpDialogVisible ? "block": "none")}}>
                            <DialogForHelpComponent
                                isEng={this.props.isEng}
                                programContainer={this.props.programContainer} 
                                dialogVisible={this.state.helpDialogVisible} 
                                callback={(visible) => {
                                    if (visible != null) {
                                        this.setState({ helpDialogVisible: false })
                                    }
                                    this.props.callback( this.props.programContainer);
                                }}>
                            </DialogForHelpComponent>
                        </div>

                        {/* <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                            <div style={{ width: '14%' }}>
                                Disable Custom Javascript:
                            </div>
                            <div style={{ alignItems: 'center', marginTop: '5px' }}>
                                <Checkbox checked={this.props.programContainer.DisableJavascript} value={this.props.programContainer.DisableJavascript}
                                    className='p-checkbox' title="Has Save Draft Button"
                                    onChange={(e) => {
                                        this.props.programContainer.DisableJavascript = e.checked;
                                        this.props.callback( this.props.programContainer);
                                    }} />
                            </div>
                        </div> */}

                        <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                            <div style={{ width: '14%' }}>
                                PDF Template:
                            </div>
                            <div style={{ width: '86%' }}>
                                {/* @ts-ignore */}
                                <FileUpload name="pdfTemplate" customUpload={true} auto={true} multiple={false}
                                    maxFileSize={5000000}
                                    onRemove={this.fileUploader}
                                    uploadHandler={this.fileUploader} />
                            </div>

                        </div>
                        <div style={{ width: '100%', display: this.props.programContainer.pdfTemplate ? "flex" : 'none', alignItems: 'center', marginTop: '5px' }}>
                            {/* <div style={{ width: '14%' }}>
                                Uploaded PDF Template:
                            </div> */}
                            <div style={{ width: '100%' }}>
                                {/* @ts-ignore */}
                                <Panel collapsed={true} toggleable header="Uploaded PDF Template">
                                    <object style={{ width: '100%', height: '100%' }} data={this.props.programContainer.pdfTemplate} />
                                    <div>
                                        {/* @ts-ignore */}
                                        <Button onClick={(e)=>{
                                            this.props.programContainer.pdfTemplate=null;
                                            this.props.callback( this.props.programContainer);
                                        }}>
                                            Remove PDF Template
                                        </Button>
                                    </div>
                                </Panel>
                            </div>
                        </div>
                        <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                            <div style={{ width: '14%' }}>
                                Creator:
                            </div>
                            <div style={{ width: '86%' }}>
                                {this.props.programContainer.Creator}
                            </div>
                        </div>
                        <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                            <div style={{ width: '14%' }}>
                                Co-owners:
                            </div>
                            <div style={{ width: '86%' }}>
                                <AzureUsersLookUpComponent userList={this.props.programContainer.Coowners}
                                    callback={(newUserList) => {
                                        this.props.programContainer.Coowners = newUserList;
                                        this.props.callback(this.props.programContainer);
                                    }}
                                />
                            </div>

                        </div>

  
                    </Panel>
                </div>
            </div>
        )

        htmlString.push(this.getFormSection(formSectionsList));

        htmlString.push(
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', verticalAlign: 'middle', alignContent: 'center' }}>
                <div className='ontario-div' >
                    {/* @ts-ignore */}
                    <Dropdown placeholder="Select a Section Template Saved Before" options={this.state.templateList} optionLabel="description" optionValue="code" onChange={(e) => {
                        let section = parseJson(e.value, this.props.programContainer.CategoryId);
                        const maxSequence = formSectionsList.reduce((max, obj) => obj.Sequence > max ? obj.Sequence : max, formSectionsList[0].Sequence);
                        section.Sequence=maxSequence+1;
                        section.Id = section.Sequence.toString();
                        formSectionsList.push(section);
                        this.props.callback( this.props.programContainer);
                    }}></Dropdown>
                </div>
                <div className='ontario-div'  >
                    {/* @ts-ignore */}
                    <Button className="p-button-warning" onClick={() => {
                        let section = new FormSections();
                        section.Visible = true;
                        section.ListOfFormSubSections = [];
                        section.parent = this.props.programContainer;
                        let subSection = new FormSubSections();
                        subSection.parent = section;
                        section.ListOfFormSubSections.push(subSection);
                        subSection.Sequence = 1;
                        if (subSection.ListOfFormSectionElements) {
                            subSection.ListOfFormSectionElements = [];
                        }
                        // section.Id = (Math.max(...formSectionsList.map(({Id}) => parseInt(Id))) + 1).toString();
                        const maxId = formSectionsList.reduce((max, item) => {
                            return Math.max(max, parseInt(item.Id))+1;
                        }, 1);
                        section.Id = maxId.toString();
                        section.ENUTitle = "Section " + section.Id;
                        section.FRATitle = "[FR] Section " + section.Id;
                        section.Sequence = formSectionsList.length + 1;
                        formSectionsList.push(section);
                        this.props.callback( this.props.programContainer);
                    }}>Add Section</Button>
                </div>
            </div>
        )
        return htmlString;
    }

    getFormSection(formSectionsList) {
        let htmlString = [];
        formSectionsList.sort((a, b) => a.Sequence - b.Sequence).forEach((formSection, index) => {

            if (formSection.ListOfFormSubSections.length == 1) {
                htmlString.push(
                    <>
                        {/* @ts-ignore */}
                        <Panel
                            key={'Panel_' + index} header={this.props.isEng ? formSection.ENUTitle + " (Sequence: " + formSection.Sequence+ ")" : formSection.FRATitle+ " (" + index+ ")"}
                            toggleable
                            collapsed={this.state.panelCollapsed[formSection.Id]}
                            onToggle={(e) => {
                                let panelArray = this.state.panelCollapsed;
                                panelArray[formSection.Id] = e.value;
                                this.setState({
                                    panelCollapsed: panelArray
                                })
                            }}>

                            {this.generateHeader(formSection)}
                            {this.generatePanels(formSection.ListOfFormSubSections[0])}
                        </Panel>
                    </>
                )
            } else {

                let panelHtml = [];
                formSection.ListOfFormSubSections.sort((a, b) => a.Sequence - b.Sequence).forEach(subSection => {
                    panelHtml.push(
                        <>
                            {/* @ts-ignore */}
                            <Panel
                                header={this.props.isEng ? subSection.ENUTitle : subSection.FRATitle || ''} toggleable>
                                {this.generatePanels(subSection)}
                            </Panel>
                        </>
                    );
                });

                htmlString.push(
                    <>
                        {/* @ts-ignore */}
                        <Panel
                            header={this.props.isEng ? formSection.ENUTitle : formSection.FRATitle || ''} toggleable
                            collapsed={this.state.panelCollapsed[formSection.Id]}
                            onToggle={(e) => {
                                let panelArray = this.state.panelCollapsed;
                                panelArray[formSection.Id] = e.value;
                                this.setState({
                                    panelCollapsed: panelArray
                                })
                            }}
                        >
                            {this.generateHeader(formSection)}
                            {panelHtml}
                        </Panel>
                    </>
                )
            }
        })

        return htmlString;
    }

    generatePanels = (subSection: FormSubSections) => {
        let htmlString = [];
        const divStyle = {
            backgroundColor: '#888888', // Specify the desired background color
            paddingTop: '10px',
            marginBottom: '10px',
            width: '100%',
        };

        htmlString.push(
            <div key={"panel_" + subSection.Sequence}>
                {this.generateSubSections(subSection)}

            </div>
        )
  
        return htmlString;
    }

    generateSubSections = (formSubSections: FormSubSections) => {
        let htmlString = [];

        let formSection = formSubSections.parent as FormSections;
        const divStyle = {
            backgroundColor: '#999999', // Specify the desired background color
            padding: '10px',
            marginBottom: '10px',
        };

        let sectionButtons = [
            {
                label: 'Setup Data API',
                visible: formSection.ListOfFormSubSections.length == formSubSections.Sequence,
                icon: 'pi pi-cloud',
                command: () => {
                    this.state.apiDialogVisible[formSection.Id] = true;
                    this.setState({ apiDialogVisible: this.state.apiDialogVisible });
                    this.props.callback( this.props.programContainer);
                }
            },
            {
                label: 'Remove Section',
                visible: formSection.ListOfFormSubSections.length === 1,
                icon: 'pi pi-times',
                command: () => {
                    this.showConfirmation(() => {
                        var formSectionsList = this.props.programContainer.ListOfFormSections.filter(p => p.Id !== formSection.Id);

                        // shift Sections's Sequence numbers so they are continuous (for move up/down to work properly)
                        for (let i=0; i<formSectionsList.length; i++) {
                            if(i==0 && formSectionsList[i].Sequence != 1) {
                                formSectionsList[i].Sequence = 1;
                            }
                            
                            if(i>0 && (formSectionsList[i].Sequence - formSectionsList[i-1].Sequence) > 1) {
                                formSectionsList[i].Sequence = formSectionsList[i-1].Sequence + 1;
                            }
                        
                        }

                        this.props.programContainer.ListOfFormSections = formSectionsList;
                        this.props.callback( this.props.programContainer);
                    });
                }
            } ,
            {
                label: 'Save Section as Template',
                visible: formSection.ENUTitle != null && formSection.ListOfFormSubSections.length == formSubSections.Sequence,
                icon: 'pi pi-star',
                command: () => {
                    let token = SessionStorageService.getAccessToken(TOKEN_TYPE.API);
                    const headers = {
                        'Authorization': `Bearer ${token}`
                    }
                    let api = "data/admin/save"
                    let entity = { categoryName: formSection.ENUTitle, formType: 'Template', attachment: stringifyJson(formSection, this.props.programContainer.CategoryId) }
                    axios.post(URLUtils.concatUrls(api), entity, { withCredentials: true, headers: headers }).then(
                        (result) => {
                            this.growl.show({ severity: 'success', summary: 'Success Message', detail: 'Template saved' });
                        }
                    ).catch((error) => {
                        const resBody = error.response.data;
                        for (const e of resBody.errors) {
                            if (resBody.message == "Data input is not valid" && e.split(':')[1] == " Application Name cannot be blank") {
                                this.growl.show({ severity: 'error', summary: 'Error Message', detail: 'Section Title cannot be blank'});
                            } else {
                                this.growl.show({ severity: 'error', summary: 'Error Message', detail: e});
                            }
                        }
                    })
                }
            },
            {
                label: 'Remove Subsection',
                icon: 'pi pi-times',
                visible: formSection.ListOfFormSubSections.length > 1,
                command: () => {
                    this.showConfirmation(() => {
                        const formSubsectionsList = formSection.ListOfFormSubSections.filter(p => p.Id !== formSubSections.Id);
                        formSection.ListOfFormSubSections = formSubsectionsList;
                        this.props.callback( this.props.programContainer);
                    });
                }
            },
            {
                label: 'Add Subsection',
                icon: 'pi pi-plus',
                visible: formSection.ENUTitle != null,
                command: () => {
                    let subSection = new FormSubSections();
                    subSection.Sequence = formSection.ListOfFormSubSections.length + 1;
                    subSection.Id = subSection.Sequence.toString();
                    subSection.parent = formSection;
                    formSection.ListOfFormSubSections.push(subSection);
                    this.props.callback( this.props.programContainer);
                }
            }
        ]

        let subSectionButtons = [
            {
                label: 'Add Subsection',
                icon: 'pi pi-plus',
                visible: formSection.ENUTitle != null,
                command: () => {
                    let subSection = new FormSubSections();
                    subSection.Sequence = formSubSections.Sequence + 1;
                    // formSubSections.Sequence=formSubSections.Sequence+1;
                    formSection.ListOfFormSubSections.forEach(p => {
                        if (p.Sequence > formSubSections.Sequence) {
                            p.Sequence = p.Sequence + 1;
                            p.Id = p.Sequence.toString();
                        }
                    })
                    subSection.Id = subSection.Sequence.toString();
                    subSection.parent = formSection;
                    formSection.ListOfFormSubSections.push(subSection);
                    this.props.callback( this.props.programContainer);
                }
            },
            {
                label: 'Remove Subsection',
                icon: 'pi pi-times',
                visible: formSection.ListOfFormSubSections.length > 1,
                command: () => {
                    this.showConfirmation(() => {
                        const formSubsectionsList = formSection.ListOfFormSubSections.filter(p => p.Id !== formSubSections.Id);

                        formSection.ListOfFormSubSections = formSubsectionsList;
                        this.props.callback( this.props.programContainer);
                    });
                }
            },

        ]


        if (formSubSections.parent["ListOfFormSubSections"].length > 1) {
            let header = (
                <div>
                    <div>
                        <InputText placeholder="Sub Section Title" title="Sub Section Title" className="ontario-input" style={{ width: '100%', }}
                            value={this.props.isEng ? formSubSections.ENUTitle : formSubSections.FRATitle} onChange={(e) => {
                                if (this.props.isEng)
                                    formSubSections.ENUTitle = e.target.value;
                                else
                                    formSubSections.FRATitle = e.target.value;

                                this.props.callback( this.props.programContainer);
                            }} />
                    </div>
                    <div style={{ width: '100%', paddingTop: '10px' }}>
                        <InputTextarea placeholder="Additional Description/Instructions" title="Additional Description/Instructions" className="ontario-input"
                            value={this.props.isEng ? formSubSections.ENUDescription : formSubSections.FRADescription} onChange={(e) => {
                                if (this.props.isEng)
                                    formSubSections.ENUDescription = e.target.value;
                                else
                                    formSubSections.FRADescription = e.target.value;

                                this.props.callback( this.props.programContainer);
                            }} />
                    </div>
                    
                </div>
            )
            htmlString.push(
                formSubSections.parent.CustomizedReviewPage
                &&
                <div style={{display:"flex", marginBottom:'5px'}}>
                    <div>
                        {/* @ts-ignore */}
                        <Checkbox id={'chk_NoCardInSummary' + formSubSections.Id} key={'chk_NoCardInSummary' + formSubSections.Id} 
                        checked={formSubSections.NoCardInSummary} 
                        onChange={(e) => {
                            formSubSections.NoCardInSummary = e.checked;
                            this.props.callback(this.props.programContainer);
                        }} ></Checkbox>
                    </div>
                    <div style={{ paddingLeft: '3px' }}>
                        <label htmlFor={'chk_NoCardInSummary' + formSubSections.Id} className="p-checkbox-label">Not inside card</label>
                    </div>
                </div>
            );
                
            htmlString.push(header);
        }

        

        formSubSections.ListOfFormSectionElements
            .sort((a, b) => a.Sequence - b.Sequence)
            .forEach((ele, index) => {
                ele.parent = formSubSections;
                let elementHtml = this.generateElement(ele);
                let sectionName = ele.ENUTitle+"";
                htmlString.push(
                    <div style={{ marginTop: '20px' }} key={ele.Id + "_panel_" + formSubSections.ENUTitle + ele.Sequence}>
                        {/* @ts-ignore */}
                        <Panel key={'Panel_' + index} header={'Element ' + (index + 1).toString() + " - " + sectionName} toggleable >
                            {elementHtml}
                        </Panel>
                    </div>

                )
            });


        if (formSubSections.parent.ListOfFormSubSections.length > 1) {
            htmlString.push(
                <div className='ontario-div' style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <div style={{ display: formSubSections.Sequence > 1 ? 'block' : 'none' }}>
                        <button className="ontario-button ontario-button--secondary" onClick={(e) => {
                            let currentIndex = formSubSections.Sequence;
                            let lastSubSection = formSubSections.parent.ListOfFormSubSections[currentIndex - 2];
                            lastSubSection.Sequence = currentIndex;
                            formSubSections.Sequence = currentIndex - 1;
                            this.props.callback(this.props.programContainer);
                        }}>Move Subsection Up</button>
                    </div>
                    <div style={{ display: formSubSections.Sequence == formSubSections.parent.ListOfFormSubSections.length ? 'none' : 'block' }}>
                        <button className="ontario-button ontario-button--secondary" onClick={(e) => {
                            let currentIndex = formSubSections.Sequence;
                            let nextSubSection = formSubSections.parent.ListOfFormSubSections[currentIndex];
                            nextSubSection.Sequence = nextSubSection.Sequence - 1;
                            formSubSections.Sequence = formSubSections.Sequence + 1;
                            this.props.callback(this.props.programContainer);
                        }}>Move Subsection Down</button>
                    </div>
                </div>
            )
        }

        htmlString.push(
            <div className='ontario-div' style={{ display: 'flex', justifyContent: 'space-between' }} key={"remove_btn_" + formSubSections.Sequence} >
                <div style={{ display: formSection.ENUTitle != null && formSection.ListOfFormSubSections.length == formSubSections.Sequence? 'block' : 'none' }}>
                    {/* @ts-ignore */}
                    <SplitButton label="Section Options" model={sectionButtons} className="p-button-warning"></SplitButton>
                </div>
                <div style={{ display: formSection.ListOfFormSubSections.length !== formSubSections.Sequence ? 'block' : 'none' }}>
                    {/* @ts-ignore */}
                    <SplitButton label="Sub-Section Options" model={subSectionButtons} className="p-button-warning"></SplitButton>
                </div>
                <div>
                    {/* @ts-ignore */}
                    <Button onClick={(e) => {
                        let sectionDialogVisible = this.state.sectionDialogVisible;
                        sectionDialogVisible[formSection.Sequence] = true;
                        this.setState({ sectionDialogVisible: sectionDialogVisible });
                    }}>Section Property</Button>
                </div>
                <div style={{ display: formSection.Sequence > 1 ? 'block' : 'none' }}>
                    {/* @ts-ignore */}
                    <Button onClick={() => {
                        let currentIndex = formSection.Sequence;
                        let lastSection = this.props.programContainer.ListOfFormSections[currentIndex - 2];
                        lastSection.Sequence = currentIndex;
                        formSection.Sequence = currentIndex - 1;
                        this.props.callback(this.props.programContainer);
                    }}>Move Up</Button>
                </div>
                <div style={{ display: formSection.Sequence == this.props.programContainer.ListOfFormSections.length ? 'none' : 'block' }}>
                    {/* @ts-ignore */}
                    <Button onClick={() => {
                        let currentIndex = formSection.Sequence;
                        let nextSection = this.props.programContainer.ListOfFormSections[currentIndex];
                        nextSection.Sequence = currentIndex;
                        formSection.Sequence = currentIndex + 1;
                        this.props.callback(this.props.programContainer);
                    }}>Move Down</Button>
                </div>
                <div style={{ display: this.state.sectionDialogVisible[formSection.Sequence] ? 'block' : 'none' }}>
                    <DialogForSectionPropertyComponent key={`dialog_section_${formSection.Sequence}`} dialogVisible={this.state.sectionDialogVisible[formSection.Sequence]}
                        formSection={formSection} isEng={this.props.isEng}
                        callback={(visible) => {
                            if (visible != null) {
                                let sectionDialogVisible = this.state.sectionDialogVisible;
                                sectionDialogVisible[formSection.Sequence] = false;
                                this.setState({ sectionDialogVisible: sectionDialogVisible })
                            }
                            this.props.callback(this.props.programContainer);
                        }}>

                    </DialogForSectionPropertyComponent>
                </div>

                <div>
                    {/* @ts-ignore */}
                    <Button style={{ cursor: 'pointer' }} onClick={() => {
                        let ele = new FormSectionElements();
                        ele.Sequence = formSubSections.ListOfFormSectionElements.length + 1;
                        ele.Datatype = 'Text';
                        ele.Editable = 'Y';
                        ele.Optional = 'Y';
                        ele.Valid = true;
                        ele.Visible=true;
                        ele.parent = formSubSections;
                        ele.Id = ele.Sequence.toString();//assign Id for comptability
                        formSubSections.ListOfFormSectionElements.push(ele);
                        this.props.callback( this.props.programContainer);
                    }}>Add Element</Button>
                </div>
            </div>
        );

        if (this.state.apiDialogVisible[formSection.Id]) {
            htmlString.push(
                <DialogForAPIComponent section={formSection} dialogVisible={this.state.apiDialogVisible[formSection.Id]} isEng={this.props.isEng}
                    callback={(visible) => {
                        if (visible != null) {
                            this.state.apiDialogVisible[formSection.Id] = false;
                            this.setState({ apiDialogVisible: this.state.apiDialogVisible })
                        }
                        this.props.callback( this.props.programContainer);
                    }
                    }>
                </DialogForAPIComponent>)
        }

        return htmlString;
    }

    generateElement = (p:FormSectionElements) => {

        let htmlString = [];

        htmlString.push(
            this.elementBlock(p)
        );

        switch (p.Datatype) {
            case 'Label':
                let val = this.props.isEng ? p.Value : p.ValueFRA || "";
                htmlString.push(<div className="card">
                    { p.displayInEditor || <Editor value={val} 
                            onTextChange={(e) => {
                                this.props.isEng ? p.Value = e.htmlValue : p.ValueFRA = e.htmlValue;
                            }}
                            style={{ height: 'auto' }}
                        />
                    }
                    { p.displayInEditor && <InputTextarea value={this.props.isEng ? p.Value : p.ValueFRA} onChange={(e) => {
                         this.props.isEng ? p.Value = e.target.value : p.ValueFRA = e.target.value
                         this.props.callback(this.props.programContainer);
                         }} style={{ height: '100px', width: '100%' }} />
                    }
                    <button onClick={() => {
                        p.displayInEditor = !p.displayInEditor;
                        this.props.callback(this.props.programContainer);
                    }} >{p.displayInEditor==true? "Raw":"HTML"}</button>
                </div>)
                break;
            case "HTML":
                try {
                    htmlString.push(<div className="card">

                        <div><InputTextarea value={this.props.isEng ? p.Value : p.ValueFRA} onChange={(e) => {
                            this.props.isEng ? p.Value = e.target.value : p.ValueFRA = e.target.value
                            this.props.callback(this.props.programContainer);
                        }} style={{ height: '100px', width: '100%' }} />
                        </div>
                    </div>)
                } catch (ex) {
                    console.log(ex);
                }
            case 'InputText':
            case 'InputTextarea':
            case 'PhoneNumber':
            case 'Date':
                break;
            case 'Numberic':
                break;
            case 'Row':
                htmlString.push(
                    <div>
                        {/* @ts-ignore */}
                        <Button style={{ cursor: 'pointer' }} onClick={() => {
                            if (p.subSectionList == null) {
                                let subSection = new FormSubSections();
                                p.subSectionList = [];
                                p.subSectionList.push(subSection);
                                subSection.parent = p;                          
                                let ele = new FormSectionElements();
                                ele.Sequence = 1;
                                ele.Datatype = 'Text';
                                ele.Editable = 'Y';
                                ele.Optional = 'Y';
                                ele.Valid = true;
                                ele.parent = subSection;
                                ele.Id = "1";  
                                subSection.ListOfFormSectionElements = [];
                                subSection.ListOfFormSectionElements.push(ele);
                            } else {
                                const subSection = p.subSectionList[0];
                                let ele = new FormSectionElements();
                                ele.Sequence =subSection.ListOfFormSectionElements.length+1 ;
                                ele.Datatype = 'Text';
                                ele.Editable = 'Y';
                                ele.Optional = 'Y';
                                ele.Valid = true;
                                ele.Visible=true;
                                ele.parent = subSection
                                ele.Id = (subSection.ListOfFormSectionElements.length+1).toString();
                                subSection.ListOfFormSectionElements.push(ele);  
                            }

                        this.props.callback( this.props.programContainer);
                        }}>Add Element</Button>
                    </div>
                );
                break;
            case 'Currency':
                htmlString.push(
                    <div style={{ display: 'flex', justifyContent: 'flex-start', width: '100%', paddingTop:'5px' }} key={"min_max_" + p.Id}>
                        <div>
                            {/* @ts-ignore */}
                            <InputNumber  placeholder={"Min Value"}
                                title={`Min Value`}
                                value={p.MinValue} mode="currency" currency="CAD" locale="en-CA"
                                onChange={(e) => {
                                    p.MinValue = e.value;
                                    this.props.callback( this.props.programContainer);
                                }} />
                        </div>
                        <div>
                            {/* @ts-ignore */}
                            <InputNumber  placeholder={"Max Value"}
                                title={`Max Value`}
                                value={p.MaxValue} mode="currency" currency="CAD" locale="en-CA"
                                onChange={(e) => {
                                    p.MaxValue = e.value;
                                    this.props.callback( this.props.programContainer);
                                }} />
                        </div>
                    </div>
                )
            case 'Checkbox':
                break;
            // case 'SummaryList':
            //     htmlString.push(<SummaryListDesignComponent ele={p} isEng={this.props.isEng}
            //         callback={() => this.props.callback(this.props.programContainer)} />
            //     )
            //     break;  
            case 'CheckGroup':
            case 'RadioButton':
            case 'Dropdown':
                htmlString.push(<DropdownDesignComponent formSection={p.parent.parent} ele={p} isEng={this.props.isEng}
                    callback={() => this.props.callback( this.props.programContainer)} />
                )
                break;
            case 'GroupDropdown':
                htmlString.push(<GroupDropdownDesignComponent formSection={p.parent.parent} ele={p} isEng={this.props.isEng}
                    callback={() => this.props.callback( this.props.programContainer)} />
                )
                break;
            case 'SelectWithRichText':
                htmlString.push(<DropdownWithRichTextDesignComponent formSection={p.parent.parent} field={p} isEng={this.props.isEng}
                    callback={() => this.props.callback( this.props.programContainer)} />
                )
                break;
            case 'Email':
                // htmlString.push(
                //     <div style={{ display: 'flex', justifyContent: 'flex-start', width: '205%', paddingTop: '10px' }} key={"chk_confirmation_" + p.Id}>
                //         <div><label htmlFor={'chk_confirmation_' + p.Id} />&nbsp;Has confirmation Email&nbsp;</div>
                //         <div><Checkbox id={'chk_confirmation_' + p.Id} checked={p.ConfirmationEmail == 'Y'} onChange={(e) => {
                //             e.checked ? p.ConfirmationEmail = 'Y' : p.ConfirmationEmail = 'N'; this.props.callback()
                //         }} ></Checkbox></div>


                //     </div>);
                break;
            case 'Table':
                break;

            case 'TableMenu':
                htmlString.push(
                    <TableMenuDesignComponent ele={p} isEng={this.props.isEng} 
                    callback={() => this.props.callback(this.props.programContainer)}/>
                );
                break;
            case 'TechError':
                const customText= this.props.isEng ? p.Value : p.ValueFRA || "";
                const content= this.props.isEng? p.ErrorContentValue:p.ErrorContentValueFRA;
                htmlString.push(<>
                    <div className="card">
                            <div>Error Content</div>

                            <div>
                                { !p.displayInEditor && <Editor value={content} style={{ height: 'auto' }}
                                    onTextChange={(e) => {
                                        if (this.props.isEng)
                                            p.ErrorContentValue = e.htmlValue
                                        else
                                            p.ErrorContentValueFRA = e.htmlValue;
                                        this.props.callback(this.props.programContainer);
                                    }} />}
                            </div>

                            <div>
                                {p.displayInEditor && <InputTextarea value={content} 
                                onChange={(e) => {
                                    if(this.props.isEng)
                                       p.ErrorContentValue = e.target.value 
                                    else
                                       p.ErrorContentValueFRA = e.target.value
                                    this.props.callback(this.props.programContainer);
                                }} style={{ height: '100px', width: '100%' }} />}
                            </div>
                  
                        <div>
                            {/* @ts-ignore */}
                            {!p.displayInEditor && <Editor value={customText} style={{ height: 'auto' }}
                                onTextChange={(e) => {
                                    if (this.props.isEng)
                                        p.Value = e.htmlValue
                                    else
                                        p.ValueFRA = e.htmlValue;
                                    this.props.callback(this.props.programContainer);
                                }
                                }
                            />}
                        </div>
                        <div>
                           {p.displayInEditor && <InputTextarea value={customText} onChange={(e) => {
                                this.props.isEng ? p.Value = e.target.value : p.ValueFRA = e.target.value
                                this.props.callback(this.props.programContainer);
                            }} style={{ height: '100px', width: '100%' }} />}
                        </div>
                        <button onClick={() => {
                            p.displayInEditor = !p.displayInEditor;
                            this.props.callback(this.props.programContainer);
                        }} >{p.displayInEditor == true ? "Raw" : "HTML"}</button>
                    </div>
                </>)
                break;
            case "SummaryList":
            case 'Excel Template':
                htmlString.push(<TableComponent ele={p} isEng={this.props.isEng}
                    callback={(dialogVisible) => {
                        if (dialogVisible != null) {
                            this.setState({ dialogVisible: dialogVisible });
                        }
                        this.props.callback( this.props.programContainer);
                    }
                    } />);
                break;

            case 'Download':
                htmlString.push(
                    <div style={{ marginTop: '5%' }}>
                        {/* @ts-ignore */}
                        <FileUpload name="attachment[]" customUpload={true} maxFileSize={5000000} onRemove={this.fileDownloadHandler.bind(this, p)} auto={true} uploadHandler={this.fileDownloadHandler.bind(this, p)} />
                    </div>
                );
                break;
            case 'Image':
                htmlString.push(
                    <div style={{ marginTop: '5%' }}>
                        {/* @ts-ignore */}
                        <FileUpload name="attachment[]" customUpload={true} maxFileSize={5000000} onRemove={this.fileDownloadHandler.bind(this, p)} auto={true} uploadHandler={this.fileDownloadHandler.bind(this, p)} />
                    </div>
                );
                break;
          
            case 'InformationAlert':
            case 'WarningAlert':
            case 'SuccessAlert':
            case 'ErrorAlert':
                htmlString.push(
                    <div style={{ width: '100%', paddingTop: '10px' }} >
                        <div style={{ paddingRight: '5px' }}>
                            <InputText className='ontario-input' placeholder='Title' title="Title" 
                                value={this.props.isEng? p.MessageTitle: p.MessageTitleFRA} 
                                onChange={(e) => {
                                    if(this.props.isEng){
                                        p.MessageTitle = e.target.value;
                                    } else {
                                        p.MessageTitleFRA = e.target.value;
                                    }
                                    
                                    this.props.callback( this.props.programContainer);
                                }} 
                            />
                        </div>

                        <div style={{ paddingRight: '5px' }}>
                            {/* @ts-ignore */}
                            { !p.displayInEditor && (
                                <Editor className='ontario-input ontario-margin-bottom-0-!' 
                                    placeholder='Message Body' title="Message Body" 
                                    value={this.props.isEng?p.MessageBody:p.MessageBodyFRA} 
                                    onTextChange={(e) => {
                                        if(this.props.isEng){
                                            p.MessageBody = e.htmlValue;
                                        } else {
                                            p.MessageBodyFRA=e.htmlValue;
                                        }
                                        this.props.callback( this.props.programContainer);
                                }}/>
                            )}
                            { p.displayInEditor && (
                                <InputTextarea value={this.props.isEng ? p.MessageBody : p.MessageBodyFRA} 
                                    onChange={(e) => {
                                        this.props.isEng ? p.MessageBody = e.target.value : p.MessageBodyFRA = e.target.value
                                        this.props.callback(this.props.programContainer);
                                    }}
                                    style={{ height: '100px', width: '100%' }} 
                                />
                            )}
                            <button onClick={() => {
                                p.displayInEditor = !p.displayInEditor;
                                this.props.callback(this.props.programContainer);
                            }}>
                                {p.displayInEditor==true? "Raw":"HTML"}
                            </button>
                        </div>
                    </div>
                );
                break;
            case 'GoogleLookUpAddress':
                htmlString.push(<div>
                    <div style={{ display: 'flex', alignItems: 'center', marginTop: '5px' }}>
                        <div style={{ width: '20%', paddingRight: '5px' }}>Unit Number</div>
                        <div>
                            <InputText className='ontario-input' placeholder='Binding field' value={p["unitNumber"]} onChange={e => {
                                p["unitNumber"] = e.target.value.split(" ").join("__");
                                this.props.callback( this.props.programContainer);
                            }}></InputText>
                        </div>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', marginTop: '5px' }}>
                        <div style={{ width: '20%', paddingRight: '5px' }}>Street Number</div>
                        <div>
                            <InputText className='ontario-input' placeholder='Binding field' value={p["streetNumber"]} onChange={e => {
                                p["streetNumber"] = e.target.value.split(" ").join("__");;
                                this.props.callback( this.props.programContainer);
                            }}></InputText>
                        </div>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', marginTop: '5px' }}>
                        <div style={{ width: '20%', paddingRight: '5px' }}>Street Name</div>
                        <div>
                            <InputText className='ontario-input' placeholder='Binding field' value={p["streetName"]} onChange={e => {
                                p["streetName"] = e.target.value.split(" ").join("__");;
                                this.props.callback( this.props.programContainer);
                            }}></InputText>
                        </div>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', marginTop: '5px' }}>
                        <div style={{ width: '20%', paddingRight: '5px' }}>Street Type</div>
                        <div>
                            <InputText className='ontario-input' placeholder='Binding field' value={p["streetType"]} onChange={e => {
                                p["streetType"] = e.target.value.split(" ").join("__");;
                                this.props.callback( this.props.programContainer);
                            }}></InputText>
                        </div>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', marginTop: '5px' }}>
                        <div style={{ width: '20%', paddingRight: '5px' }}>Street Direction</div>
                        <div>
                            <InputText className='ontario-input' placeholder='Binding field' value={p["streetDirection"]} onChange={e => {
                                p["streetDirection"] = e.target.value.split(" ").join("__");;
                                this.props.callback( this.props.programContainer);
                            }}></InputText>
                        </div>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', marginTop: '5px' }}>
                        <div style={{ width: '20%', paddingRight: '5px' }}>P.O. Box</div>
                        <div>
                            <InputText className='ontario-input' placeholder='Binding field' value={p["POBox"]} onChange={e => {
                                p["POBox"] = e.target.value.split(" ").join("__");;
                                this.props.callback( this.props.programContainer);
                            }}></InputText>
                        </div>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', marginTop: '5px' }}>
                        <div style={{ width: '20%', paddingRight: '5px' }}>City/town</div>
                        <div>
                            <InputText className='ontario-input' placeholder='Binding field' value={p["city"]} onChange={e => {
                                p["city"] = e.target.value.split(" ").join("__");;
                                this.props.callback( this.props.programContainer);
                            }}></InputText>
                        </div>
                    </div>

                    <div style={{ display: 'flex', alignItems: 'center', marginTop: '5px' }}>
                        <div style={{ width: '20%', paddingRight: '5px' }}>Province</div>
                        <div>
                            <InputText className='ontario-input' placeholder='Binding field' value={p["province"]} onChange={e => {
                                p["province"] = e.target.value.split(" ").join("__");;
                                this.props.callback( this.props.programContainer);
                            }}></InputText>
                        </div>
                    </div>

                    <div style={{ display: 'flex', alignItems: 'center', marginTop: '5px' }}>
                        <div style={{ width: '20%', paddingRight: '5px' }}>Postal Code</div>
                        <div>
                            <InputText className='ontario-input' placeholder='Binding field' value={p["postalCode"]} onChange={e => {
                                p["postalCode"] = e.target.value.split(" ").join("__");;
                                this.props.callback( this.props.programContainer);
                            }}></InputText>
                        </div>

                    </div>
                </div>
                );
                break;
            case 'HTMLTemplate':
                break;
            case 'StartRating':
                htmlString.push(
                    <StarRating
                        title={this.props.isEng ? p.ENUTitle : p.FRATitle}
                        isEng={this.props.isEng}
                        field={p}
                        callbackElement={p => this.props.callback(p)}
                    />
                );
                break;
            case 'QRCode':
                //const env = process.env.ENV || 'dev';
                const url = EnvBaseUrl.prod + '/' + this.props.programContainer.CategoryId;
                htmlString.push(
                    <QRCodeComponent value={url} size={100}/>
                );
                break;
            case 'Accordions':
                const setAccordions = (accordions: AccordionData[], expandAll=false) => {
                    if (this.props.isEng) {
                        p.accordions = { expandAll: expandAll, accordions: accordions};
                    } else {
                        p.accordionsFRA = { expandAll: expandAll, accordions: accordions};
                    }
                    this.props.callback(getRootComponent(p));
                }
                htmlString.push(
                    <AccordionsDesignComponent 
                        field={p} 
                        isEng={this.props.isEng} 
                        setAccordion={setAccordions}
                        callBackElement={p =>this.props.callback(p)}
                    />
                );
                break;
            case 'RecaptchaButton':
                htmlString.push(
                    <div style={{ width: '100%', padding: '0.5rem', border: '1px solid', marginTop: '1rem'}} >
                        <div className="ontario-margin-top-12-!" style={{display: 'flex', alignItems: 'center'}}>
                            <label htmlFor={`recaptcha_api_${p.Id}`} style={{width: '12rem'}}>API: </label>
                            <InputText id={`recaptcha_api_${p.Id}`} className='ontario-input' placeholder='API' title="API" 
                                value={p.Recaptcha?.api} 
                                onChange={(e) =>{
                                    if (!p.Recaptcha) {
                                        p.Recaptcha = {content: {en: '', fr: ''}, action: '', handlerName: ''};
                                    }
                                    p.Recaptcha.api = e.target.value;
                                    this.props.callback( this.props.programContainer);
                                }} 
                            />
                        </div>
                        <div className="ontario-margin-top-12-!" style={{display: 'flex', alignItems: 'center'}}>
                            <label htmlFor={`recaptcha_action_${p.Id}`} style={{width: '12rem'}}>Action: </label>
                            <InputText id={`recaptcha_action_${p.Id}`} className='ontario-input' placeholder='Recaptcha Action' title="Action" 
                                value={p.Recaptcha?.action} 
                                onChange={(e) =>{
                                    if (!p.Recaptcha) {
                                        p.Recaptcha = {content: {en: '', fr: ''}, action: '', handlerName: ''};
                                    }
                                    p.Recaptcha.action = e.target.value;
                                    this.props.callback( this.props.programContainer);
                                }} 
                            />
                        </div>
                        <div className="ontario-margin-top-12-!" style={{display: 'flex', alignItems: 'center'}}>
                            <label htmlFor={`recaptcha_handler_name_${p.Id}`} style={{width: '12rem'}}>Hanlder name: </label>
                            <InputText id={`recaptcha_handler_name_${p.Id}`} className='ontario-input' placeholder='Recaptcha handler name' title="Handler name" 
                                value={p.Recaptcha?.handlerName} 
                                onChange={(e) =>{
                                    if (!p.Recaptcha) {
                                        p.Recaptcha = {content: {en: '', fr: ''}, action: '', handlerName: ''};
                                    }
                                    p.Recaptcha.handlerName = e.target.value;
                                    this.props.callback( this.props.programContainer);
                                }} 
                            />
                        </div>
                        <div className="ontario-margin-top-12-!">
                            <label htmlFor={`recaptcha_content_${p.Id}`}  style={{marginBottom: '0.5rem'}}>Recaptcha content: </label>
                            <div className="card">
                                { p.displayInEditor || (
                                    <>
                                        {/* @ts-ignore */ }
                                        <Editor id={`recaptcha_content_${p.Id}`} 
                                            placeholder='Recatcha button title' title="Recaptcha Submit" style={{ height: 'auto' }}    
                                            value={this.props.isEng? p.Recaptcha?.content.en : p.Recaptcha?.content.fr} 
                                            onTextChange={(e) => {
                                                const lang = this.props.isEng ? 'en' : 'fr';
                                                p.Recaptcha = {
                                                    ...p.Recaptcha ?? {action: '', handlerName: ''},
                                                    content: { ...p.Recaptcha?.content ?? {}, [lang]: e.htmlValue },
                                                };
                                                this.props.callback( this.props.programContainer);
                                        }} />
                                    </>
                                )}
                                { p.displayInEditor && (
                                    <InputTextarea id={`recaptcha_content_${p.Id}`} 
                                        style={{ height: '100px', width: '100%' }} 
                                        value={this.props.isEng? p.Recaptcha?.content.en : p.Recaptcha?.content.fr} 
                                        onChange={(e) => {
                                            const lang = this.props.isEng ? 'en' : 'fr';
                                            p.Recaptcha = {
                                                ...p.Recaptcha ?? {action: '', handlerName: ''},
                                                content: { ...p.Recaptcha?.content ?? {}, [lang]: e.target.value },
                                            };
                                            this.props.callback( this.props.programContainer);
                                    }} />
                                )}
                                <button 
                                    onClick={() => {
                                        p.displayInEditor = !p.displayInEditor;
                                        this.props.callback(this.props.programContainer);
                                }} >
                                    {p.displayInEditor==true? "Raw":"HTML"}
                                </button>
                            </div>
                        </div>
                    </div>
                );
                break;
        }

        htmlString.push(<MoreButtonComponent ele={p} isEng={this.props.isEng} callback={() => this.props.callback( this.props.programContainer)} />);

        return htmlString;
    }

    elementBlock = (p: FormSectionElements) => {
        let html = [];
        let subHtml=[];
        if (p.richTextChecked) {
            subHtml.push(<div style={{ width: '50%', paddingRight: '5px' }}>
                {/* @ts-ignore */}
                <Editor className='ontario-input' placeholder={this.props.isEng ? `Element label (Required)` : 'French Element label (Required)'}
                    title={this.props.isEng ? `Element label (Required)` : 'French Element label (Required)'} required
                    value={this.props.isEng ? p.ENUTitle : p.FRATitle || ''}
                    onTextChange={(e) => {
                        if (this.props.isEng)
                            p.ENUTitle = e.htmlValue;
                        else
                            p.FRATitle = e.htmlValue;

                        const textOnly = e.htmlValue.replace(/<[^>]+>/g, "");
                        p.LoadBindName = textOnly.split(" ").join("__");
                        this.props.callback( this.props.programContainer);
                    }} />
            </div>
            )
        } else {
            subHtml.push(<div style={{ width: '50%', paddingRight: '5px' }}>
                <InputText className='ontario-input' placeholder={this.props.isEng ? `Element label (Required)` : 'French Element label (Required)'}
                    title={this.props.isEng ? `Element label (Required)` : 'French Element label (Required)'} required
                    value={this.props.isEng ? p.ENUTitle : p.FRATitle || ''}
                    onChange={(e) => {
                        if (this.props.isEng) {
                            p.ENUTitle = e.target.value;
                        }
                        else {
                            p.FRATitle = e.target.value;
                        }
                       p.LoadBindName = p.ENUTitle?.split(" ").join("__");
                        this.props.callback( this.props.programContainer);
                    }} />
            </div>)
        }

        html.push(<div key={p.parent.Id + "_element_" + p.Sequence?.toString()} >

            <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-start', paddingTop: '10px' }} >
                {subHtml}
                <div style={{ display: 'flex', justifyContent: 'flex-start', width: '20%', paddingLeft: '5px' }} key={"chk_" + p.Id}>
                    <div><label htmlFor={'chk_' + p.Id} />&nbsp;Required&nbsp;</div>
                    <div>
                        {/* @ts-ignore */}
                        <Checkbox id={'chk_' + p.Id} disabled={this.props.isEng == false} checked={p.Optional == 'N'}
                            onChange={(e) => {
                                e.checked ? p.Optional = 'N' : p.Optional = 'Y';
                                this.props.callback( this.props.programContainer)
                            }}>
                        </Checkbox>
                    </div>
                </div>
                <div style={{ display: 'flex', justifyContent: 'flex-start', width: '25%', paddingLeft: '5px' }} key={"chk_readonly_" + p.Id}>
                    <div><label htmlFor={'chk_readonly_' + p.Id} />&nbsp;Read Only&nbsp;</div>
                    <div>
                        {/* @ts-ignore */}
                        <Checkbox id={'chk_readonly_' + p.Id} disabled={this.props.isEng == false} checked={p.ReadOnly} onChange={(e) => {
                            p.ReadOnly = e.checked; this.props.callback( this.props.programContainer)
                        }}></Checkbox>
                    </div>
                </div>
                <div style={{ display: 'flex', justifyContent: 'flex-start', width: '10%', paddingLeft: '5px' }} key={"chk_readonly_richtext" + p.Id}>
                    <div><label htmlFor={'chk_richtext' + p.Id + p.Sequence?.toString()} />Rich Text&nbsp;</div>
                    <div>
                        {/* @ts-ignore */}
                        <Checkbox id={'chk_richtext' + p.Id + p.Sequence?.toString()} disabled={this.props.isEng == false}
                            checked={p.richTextChecked}
                            onChange={(e) => {
                                p.richTextChecked = e.checked;
                                this.props.callback( this.props.programContainer)
                            }}>
                        </Checkbox>
                    </div>
                </div>
            </div>
            <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-start', paddingTop: '10px' }} >
                <div style={{ width: '50%', paddingRight: '5px' }}>
                    <InputText className='ontario-input' disabled={this.props.isEng == false} placeholder='Binding field name' title="Binding field name" value={p.LoadBindName} onChange={(e) => {
                        p.LoadBindName = e.target.value;
                        this.props.callback( this.props.programContainer);
                    }} />
                </div>
                <div style={{ width: p.Datatype == 'Dropdown' ? '25%' : '50%', paddingLeft: '5px' }} >
                    {/* @ts-ignore */}
                    <Dropdown title="Field type" 
                        disabled={this.props.isEng == false} 
                        optionLabel="label" 
                        optionValue='val' 
                        options={elementTypeList} 
                        value={p.Datatype}
                        onChange={(e) => {
                            p.Datatype = e.value;
                            this.props.callback( this.props.programContainer);
                        }}
                    />
                </div>
                <div style={{ display: p.Datatype == 'Dropdown' ? "flex" : "none", width: '25%', justifyContent: 'flex-start', paddingLeft: '5px' }}>
                    <div><label htmlFor={'chk_readonly_' + p.AddEmptyItemToList} />&nbsp;Add empty option&nbsp;</div>
                    <div>
                        {/* @ts-ignore */}
                        <Checkbox id={'chk_readonly_' + p.AddEmptyItemToList} checked={p.AddEmptyItemToList == 'Y'}
                            onChange={(e) => {
                                e.checked ? p.AddEmptyItemToList = 'Y' : p.AddEmptyItemToList = 'N';
                                this.props.callback( this.props.programContainer);
                            }}>
                        </Checkbox>
                    </div>
                </div>

                <div style={{ display: p.Datatype == 'Row' ? "flex" : "none", justifyContent: 'flex-start', paddingRight: '5px' }}>
                    <div><label htmlFor={'chk_readonly_' + p.AddEmptyItemToList} />Gap</div>
                    <div style={{ paddingRight: '5px', }}>
                        <InputText className='ontario-input' disabled={this.props.isEng == false} placeholder='Gap in px' title="gap between controls in the same row" value={p.Gap}
                            onChange={(e) => {
                                p.Gap = e.target.value;
                                this.props.callback(this.props.programContainer);
                            }} />
                    </div>
                </div>

            </div>

        </div>);

        const rowHtml = this.generateRowHtml(p)

        html.push(rowHtml);

        return html;
    }

    generateRowHtml = (p: FormSectionElements) => {
        let rowHtml = [];
        if (p.Datatype == "Row") {
           if (p.subSectionList != null) {
                p.subSectionList[0]?.ListOfFormSectionElements.forEach(q => {
                    rowHtml.push(<p>
                        <div key={q.parent.Id + "_element_" + q.Sequence.toString() } >

                            <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-start', paddingTop: '10px' }} >
                                <div style={{ width: '50%', paddingRight: '5px' }}>
                                    <InputText className='ontario-input' placeholder={this.props.isEng ? `Element label (Required)` : 'French Element label (Required)'}
                                        title={this.props.isEng ? `Element label (Required)` : 'French Element label (Required)'} required
                                        value={this.props.isEng ? q.ENUTitle : q.FRATitle || ''}
                                        onChange={(e) => {
                                            if (this.props.isEng) {
                                                q.ENUTitle = e.target.value;
                                            }
                                            else {
                                                q.FRATitle = e.target.value;
                                            }
                                            q.LoadBindName = q.ENUTitle?.split(" ").join("__");
                                            this.props.callback( this.props.programContainer);
                                        }} />
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'flex-start', width: '20%', paddingLeft: '5px' }} key={"chk_row_" + q.Id}>
                                    <div><label htmlFor={'chk_row_' + q.Id} />&nbsp;Required&nbsp;</div>
                                    <div>
                                         <Checkbox id={'chk_row_' + q.Id} disabled={this.props.isEng == false} checked={q.Optional == 'N'}
                                            onChange={(e) => {
                                                e.checked ? q.Optional = 'N' : q.Optional = 'Y';
                                                this.props.callback( this.props.programContainer)
                                            }}>
                                        </Checkbox>
                                    </div>
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'flex-start', width: '25%', paddingLeft: '5px' }} key={"chk_readonly_row_" + q.Id}>
                                    <div><label htmlFor={'chk_readonly_row_' + q.Id} />&nbsp;Read Only&nbsp;</div>
                                    <div>
                                        <Checkbox id={'chk_readonly_row_' + q.Id} disabled={this.props.isEng == false} checked={q.Editable == 'N'} onChange={(e) => {
                                            e.checked ? q.Editable = 'N' : q.Editable = 'Y'; this.props.callback( this.props.programContainer)
                                        }}></Checkbox>
                                    </div>
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'flex-start', width: '10%', paddingLeft: '5px' }} key={"chk_richtext_row_" + q.Id}>
                                    <div><label htmlFor={'chk_richtext_row_' + q.Id + q.Sequence.toString()} />Rich Text&nbsp;</div>
                                    <div>
                                       <Checkbox id={'chk_richtext_row_' + q.Id + q.Sequence.toString()} disabled={this.props.isEng == false}
                                            checked={q.richTextChecked}
                                            onChange={(e) => {
                                                q.richTextChecked = e.checked;
                                                this.props.callback( this.props.programContainer)
                                            }}>
                                        </Checkbox>
                                    </div>
                                </div>
                            </div>
                            <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-start', paddingTop: '10px' }} >
                                <div style={{ width: '50%', paddingRight: '5px' }}>
                                    <InputText className='ontario-input' disabled={this.props.isEng == false} placeholder='Binding field name' title="Binding field name" value={q.LoadBindName} onChange={(e) => {
                                        q.LoadBindName = e.target.value;
                                        this.props.callback( this.props.programContainer);
                                    }} />
                                </div>
                                <div style={{ width: q.Datatype == 'Dropdown' ? '25%' : '50%', paddingLeft: '5px' }} >
                                    <Dropdown title="Field type" 
                                        disabled={this.props.isEng == false} 
                                        optionLabel="label" optionValue='val' 
                                        options={elementTypeList} 
                                        value={q.Datatype}
                                        onChange={(e) => {
                                            q.Datatype = e.value;
                                            this.props.callback( this.props.programContainer);
                                        }}></Dropdown>
                                </div>
                            </div>
                            <div style={{ display: q.Datatype == "Label" ? "block" : "none" }}>
                                <div className="card">
                                    <div style={{ display: p.displayInEditor ? "none" : "block" }}>
                                        {/* @ts-ignore */}
                                        <Editor value={this.props.isEng ? p.Value : p.ValueFRA} onTextChange={(e) => this.props.isEng ? p.Value = e.htmlValue : p.ValueFRA = e.htmlValue} style={{ height: 'auto' }} />
                                    </div>
                                    <div style={{ display: p.displayInEditor ? "block" : "none", width: '100%' }}><InputTextarea value={this.props.isEng ? p.Value : p.ValueFRA} onChange={(e) => {
                                        this.props.isEng ? p.Value = e.target.value : p.ValueFRA = e.target.value
                                        this.props.callback(this.props.programContainer);
                                    }} style={{ height: '100px', width: '100%' }} />
                                    </div>
                                    <button onClick={() => {
                                        p.displayInEditor = !p.displayInEditor;
                                        this.props.callback(this.props.programContainer);
                                    }} >{p.displayInEditor == true ? "Raw" : "HTML"}</button>
                                </div>
                            </div>
                        </div></p>
                    );

                    rowHtml.push(<p><MoreButtonComponent ele={q} isEng={this.props.isEng} callback={() => this.props.callback( this.props.programContainer)} /></p>);
                })
            }

            return rowHtml.length>0?
                <div >
                    <Panel >{rowHtml}</Panel>
                </div>
                :null;
        }
        return null;

    }

    generateHeader = (formSection: FormSections) => {

        let titleVal = this.props.isEng ? formSection.ENUTitle : formSection.FRATitle;;
        let descriptionVal = this.props.isEng ? formSection.ENUDescription : formSection.FRADescription;
        const divStyle = {
            backgroundColor: '#BBBBBB', // Specify the desired background color
            padding: '10px',
            marginBottom: '10px',
        };

        return (
            <div>
                <div>
                    <InputText placeholder="Section Title" title="Section Title" className="ontario-input" style={{ width: '100%', }}
                        value={titleVal || ''} onChange={(e) => {
                            if (this.props.isEng)
                                formSection.ENUTitle = e.target.value;
                            else
                                formSection.FRATitle = e.target.value;

                            this.props.callback( this.props.programContainer);
                        }} />
                </div>

                <div style={{ width: '100%', paddingTop: '10px' }}>
                    <InputTextarea placeholder="Additional Description/Instructions" title="Additional Description/Instructions" className="ontario-input"
                        value={descriptionVal || ''} onChange={(e) => {
                            if (this.props.isEng)
                                formSection.ENUDescription = e.target.value;
                            else
                                formSection.FRADescription = e.target.value;

                            this.props.callback( this.props.programContainer);
                        }}
                    />
                </div>
                {/* <div style={{ width: '100%', paddingTop: '10px' }}>
                    <InputText placeholder="Business Entity" title="Business Entity" className="ontario-input" style={{ width: '100%', }}
                        value={formSection.EntityName} onChange={(e) => {
                            formSection.EntityName = e.target.value;
                            this.props.callback();
                        }} />
                </div> */}
                <div style={{ display: 'flex', paddingTop: '10px' }}>
                    {/* when stepper is selected */}
                    {this.props.programContainer.displayForm !== 'NoIndicatorStepper'  && (
                        <>
                            <div>
                                {/* @ts-ignore */}
                                <Checkbox id={'chk_section_IsStepper' + formSection.Id} key={'chk_section_IsStepper' + formSection.Id} checked={formSection.NotStep} onChange={(e) => {
                                    formSection.NotStep = e.checked;
                                    this.props.callback( this.props.programContainer);
                                }} ></Checkbox>
                            </div>
                            <div style={{ paddingLeft: '3px' }}>
                                <label htmlFor={'chk_section_IsStepper' + formSection.Id} className="p-checkbox-label">Not a Step</label>
                            </div>
                            <div>
                                {/* @ts-ignore */}
                                <Checkbox id={'chk_section_NoStepIndicator' + formSection.Id} key={'chk_section_NoStepIndicator' + formSection.Id} checked={formSection.NoStepIndicator} onChange={(e) => {
                                    formSection.NoStepIndicator = e.checked;
                                    this.props.callback( this.props.programContainer);
                                }} ></Checkbox>
                            </div>
                            <div style={{ paddingLeft: '3px' }}>
                                <label htmlFor={'chk_section_NoStepIndicator' + formSection.Id} className="p-checkbox-label">No Step Indicator</label>
                            </div>
                        </>
                    )}
                    
                    <div>
                        {/* @ts-ignore */}
                        <Checkbox id={'chk_section_' + formSection.Id} checked={formSection.CustomizedReviewPage} onChange={(e) => {
                            formSection.CustomizedReviewPage = e.checked
                            this.props.callback( this.props.programContainer);
                        }} ></Checkbox>
                    </div>
                    <div style={{ paddingLeft: '3px' }}>
                        <label htmlFor={'chk_section_' + formSection.Id} className="p-checkbox-label">Customized Review Page</label>
                    </div>
                    
                    <div>
                        {/* @ts-ignore */}
                        <Checkbox id={'chk_section_tech_error' + formSection.Id} checked={formSection.IsTechErrorPage} onChange={(e) => {
                            formSection.IsTechErrorPage = e.checked
                            this.props.callback( this.props.programContainer);
                        }} ></Checkbox>
                    </div>
                    <div style={{ paddingLeft: '3px' }}>
                        <label htmlFor={'chk_section_' + formSection.Id} className="p-checkbox-label">Is Tech Error Page</label>
                    </div>
                    <div>
                        {/* @ts-ignore */}
                        <Checkbox id={'chk_No_Total_Number_Pages' + formSection.Id} checked={formSection.NoTotalPages} onChange={(e) => {
                            formSection.NoTotalPages = e.checked;
                            formSection.Visible=false;
                            this.props.callback( this.props.programContainer);
                        }} ></Checkbox>
                    </div>
                    <div style={{ paddingLeft: '3px' }}>
                        <label htmlFor={'chk_section_' + formSection.Id} className="p-checkbox-label">No Total Number of Pages</label>
                    </div>
                    <div>
                        {/* @ts-ignore */}
                        <Checkbox id={'chk_Info Page' + formSection.Id} checked={formSection.IsInfoPage} onChange={(e) => {
                            formSection.IsInfoPage = e.checked
                            this.props.callback( this.props.programContainer);
                        }} ></Checkbox>
                    </div>
                    <div style={{ paddingLeft: '3px' }}>
                        <label htmlFor={'chk_section_' + formSection.Id} className="p-checkbox-label">Info Page</label>
                    </div>
                    
                    <div>
                        {/* @ts-ignore */}
                        <Checkbox id={'chk_confoirmation_Page' + formSection.Id} checked={formSection.IsConfirmationPage} onChange={(e) => {
                            formSection.IsConfirmationPage = e.checked
                            this.props.callback( this.props.programContainer);
                        }} ></Checkbox>
                    </div>
                    <div style={{ paddingLeft: '3px' }}>
                        <label htmlFor={'chk_section_' + formSection.Id} className="p-checkbox-label">Confirmation Page</label>
                    </div>
                    <div>
                        {/* @ts-ignore */}
                        <Checkbox id={'chk_title_in_step_' + formSection.Id} checked={formSection.TitleInStepIndicator} onChange={(e) => {
                            formSection.TitleInStepIndicator = e.checked
                            this.props.callback( this.props.programContainer);
                        }} ></Checkbox>
                    </div>
                    <div style={{ paddingLeft: '3px' }}>
                        <label htmlFor={'chk_section_' + formSection.Id} className="p-checkbox-label">Title displayed in Step Indicator</label>
                    </div>
                </div>

                {/* {this.props.programContainer.displayForm !== 'NoIndicatorStepper' && this.props.programContainer.displayForm !== 'progressBarStepper' && !formSection.NotStep && (
                    <div className="ontario-margin-top-12-!">
                        <InputTextarea placeholder="Step title" title="step title" className="ontario-input"
                            value={formSection.stepTitle} onChange={(e) => {
                                if (this.props.isEng)
                                    formSection.stepTitle = e.target.value;
                                else
                                    formSection.stepTitleFRA = e.target.value;
                                this.props.callback( this.props.programContainer);
                            }}
                        />
                    </div>
                )} */}
            </div>
        );
    }

    fileDownloadHandler = async (p, files) => {
        let worksheetNames = [];
        let attachment = {
            content: null,
            fileName: null,
            fileType: null
        }

        for (const file of files.files) {
            var reader = new FileReader();
            const readFile = () => {
                return new Promise<void>((resolve, reject) => {
                    reader.readAsDataURL(file);
                    reader.onload = function (e) {
                        attachment.content = reader.result;
                        attachment.fileName = file.name;
                        attachment.fileType = file.type;
                        resolve();
                    }

                    reader.onerror = function (e) {
                        reject(e);
                    };
                })
            }
            await readFile();
        }

        p.Value = attachment;

    };

    generateFileValue(p) {
        p.Value = this.attachment;
        const divStyle = {
            backgroundColor: '#CCCCCC', // Specify the desired background color
            padding: '10px',
            marginBottom: '10px',
        };

        const divElement = document.createElement('div');
        Object.assign(divElement.style, divStyle);
    }

    fileUploader = (e) => {
        if (!e.files) return;
        
        e.files.forEach(element => {
            var reader = new FileReader();
            reader.onload = () => {
                this.props.programContainer.pdfTemplate = this.convertArrayBufferToString(reader.result);

                PdfUtils.generateProgramContainer(this.props.programContainer).then(programContainer => {
                    // this.props.callback(programContainer);
                })
            }

            reader.readAsDataURL(element);
        });
    };

    convertArrayBufferToString = (input: string | ArrayBuffer) => {
        if (typeof input == 'string') {
            return input;
        } else {
            const textDecoder = new TextDecoder('utf-8'); // 'utf-8' is the most common encoding
            const text = textDecoder.decode(input);
            return text;
        }
    }

    render() {
        if (
            this.props.programContainer == null ||
            this.props.programContainer.ListOfFormSections == null
        )
            return null;
        console.log(this.props.programContainer);
        return (
            <div>
                {/* @ts-ignore */}
                <Toast ref={(el) => this.growl = el} />
                {this.generateForm()}

                {/* @ts-ignore */}
                <ConfirmDialog
                    visible={this.state.confirmVisible}
                    onHide={() => this.setState({ confirmVisible: false })}
                    message="Are you sure you want to remove this?"
                    header="Confirmation"
                    icon="pi pi-exclamation-triangle"
                    accept={() => this.confirmRemove(true)}
                    reject={() => this.confirmRemove(false)}
                    closable={false}
                />
            </div>
        );
    }
}
